import { h as hex2Rgb } from './text-21866551.js';

function getRgbaFromHex(hex, alpha = 1) {
    var _a;
    const rgb = hex2Rgb(hex);
    if (!rgb) {
        return null;
    }
    return `rgba(${rgb.red}, ${rgb.green}, ${rgb.blue}, ${(_a = rgb === null || rgb === void 0 ? void 0 : rgb.alpha) !== null && _a !== void 0 ? _a : alpha})`;
}

export { getRgbaFromHex as g };
